function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

loadScript("https://razorpay.com/build/analytics-sdk/razorAnalytics-13.min.js")
  .then(initializeRazorAnalytics)
  .catch((error) => {
    console.error('Failed to load analytics script:', error);
  });

function initializeRazorAnalytics() {
  try {
    const { lumberjack, segment } = window.razorAnalyticsPlugins;

    window.razorAnalytics.init({
      plugins: [lumberjack({ environment: "production" }), segment()],
      mode: "live",
      eventProperties: {
        locale: "IN",
        app: "frontend-website",
      },
      pageConfig: {
        captureSearchParams: true,
      },
      autoCapture: {
        enabled: true,
        buttonClick: {
          captureTextContent: true,
        },
        linkClick: {
          captureTextContent: true,
          captureSearchParams: true,
        },
        scroll: {
          enabled: true,
        },
      },
    });
  } catch (error) {
    console.error(error);
  }
}